var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import MagaluService, { isSuccess } from '@magalu/webzord';
export var useZipCode = function (zipCode, action, logger) {
    if (action === void 0) { action = 'put'; }
    if (logger === void 0) { logger = console; }
    return new Promise(function (resolve, reject) {
        var args = {};
        if (action === 'put') {
            args['zipcode'] = zipCode;
        }
        try {
            MagaluService.request({
                serviceName: 'navigation.zipcode',
                callbackId: 'set-zip-code',
                serviceArgs: __assign({ action: action }, args),
                callback: function (result) {
                    if (isSuccess(result)) {
                        var zipcode = result.body.zipcode;
                        resolve({ zipCode: zipcode });
                    }
                    else {
                        logger.error("[useZipCode] action: ".concat(action, " - error"), result);
                        reject(result);
                    }
                },
            });
        }
        catch (error) {
            logger.error("[useZipCode] action: ".concat(action, " - error - catch"), error);
            reject(error);
        }
    });
};
